import React from "react";
import useMathjax from "../../../hooks/useMathjax";

const SolutionComponent = (props) => {
  const { solutionData: data, pageKey } = props;

  return (
    <>
      {pageKey == 0 && (
        <div
          style={{
            "page-break-inside": "avoid",
            marginTop: "0.5rem",
            marginBottom: "0.3rem",
            paddingBottom: "0.3rem",
            fontFamily: "'Times New Roman', Times, serif",
            fontSize:'17px',
          }}
        >
          <div
            className="row answerFont"
          // style={{ gap: "10px" }}
          >
            <div className="col-1 text-align-right" style={{ textAlign: "right" }}>{data.display_number}.</div>
            <div className="col-11">
              <b>Answer:</b> {data.answer}
              
            </div>
            
          </div>
          <div className="row">
            <div className="col-1"></div>
            <div className="col-11 row">
              <div className="col-5">
              <b>Sol:</b>
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.sol_text,
                  }}
                />
              </div>
              <div className="col-2"></div>
              <div className="col-5">
                <div
                  dangerouslySetInnerHTML={{
                    __html: data.sol_text_hindi,
                  }}
                  style={{ fontSize:'17px' }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {pageKey == 1 && (
        <div
          className="d-flex align-items-baseline gap-1 answerFont"
          style={{
            "page-break-inside": "auto",
            width: "95%",
            marginTop: "0.8rem",
            marginBottom: "0.8rem",
            paddingBottom: "0.8rem",
            paddingLeft: '1.3rem',
            fontFamily: "'Times New Roman', Times, serif",
            fontSize:'17px',
          }}
        >
          <b style={{ textAlign: "right" }}>{data.display_number}.</b>
          <div className="">
            <div>
              <b>Answer:</b> {data.answer}
            </div>
            <b>Sol:</b>
            <div
              dangerouslySetInnerHTML={{
                __html: data.sol_text,
              }}
              style={{ fontSize:'17px' }}
            />
          </div>
        </div>
      )}
      {pageKey == 2 && (
        <div
          className="d-flex align-items-baseline gap-3"
          style={{
            "page-break-inside": "auto",
            width: "95%",
            marginTop: "0.5rem",
            paddingBottom: "0.8rem",
            fontFamily: "'Times New Roman', Times, serif",
            fontSize:'17px',
          }}
        >
          <b style={{ textAlign: "right" }}>{data.display_number}.</b>
          <div className="">
            <div>
              <b>Answer:</b> {data.answer}
            </div>
            <b>Sol:</b>
            <div
              dangerouslySetInnerHTML={{
                __html: data.sol_text_hindi,
              }}
              style={{ fontSize:'17px' }}
            />
          </div>
        </div>
      )}
      {pageKey == 5 && (
        <div
          className="d-flex align-items-baseline gap-3 answerFont"
          style={{
            "page-break-inside": "auto",
            width: "95%",
            marginTop: "0.8rem",
            marginBottom: "0.8rem",
            paddingBottom: "0.8rem",
            // paddingLeft: '1.3rem',
            fontFamily: "'Times New Roman', Times, serif",
            fontSize:'17px',
          }}
        >
          <b style={{ textAlign: "right" }}>{data.display_number}.</b>
          <div className="">
            <div
              dangerouslySetInnerHTML={{
                __html: data.q_text,
              }}
              style={{ fontSize:'17px' }}
            />
            {(data.eng_option) && data.eng_option?.split("@")?.map((option, index) => {
              return (
                <div key={1} className="col-md-12 col-sm-12 col-xs-12 d-flex gap-2  mb-2" >
                  <p>
                    {`(${String.fromCharCode(65 + index)})`}
                  </p>
                  <div dangerouslySetInnerHTML={{ __html: option }} />
                </div>
              )
            })}
            <div>
              <b>Answer:</b> {data.answer}
            </div>
            <b>Sol:</b>
            <div
              dangerouslySetInnerHTML={{
                __html: data.sol_text_hindi,
              }}
            />
          </div>
        </div>
      )}
      {(pageKey == 3 || pageKey == 4) && (
        <div
          className="d-flex align-items-baseline gap-3 answerFont"
          style={{
            "page-break-inside": "avoid",
            width: "95%",
            marginTop: "0.5rem",
            paddingBottom: "1.5rem",
            fontFamily: "'Times New Roman', Times, serif",
            fontSize:'17px',
          }}
        >
          <b style={{ textAlign: "center" }}>{data.display_number}.</b>
          <div className="">
            <div>
              <b>Answer:</b> {data.answer}
            </div>
            <b>Sol:</b>
            <div
              dangerouslySetInnerHTML={{
                __html: data.sol_text_hindi,
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SolutionComponent;
